import React from 'react';
export function Footer() {
  return <footer className="border-t border-[#38206A] bg-[#24212A] px-5 py-10 text-[#E9E4F1] sm:px-8" data-id="element-37" data-mp="32wd2cf6gdjt0">
      <div className="mx-auto max-w-6xl text-center" data-id="element-38" data-mp="3ggu1qsai619z">
        <p className="font-serif text-2xl text-white" data-id="element-39" data-mp="32oe1u0cwejda">
          El Oráculo del Terapeuta™
        </p>
        <p className="mt-2 text-sm text-[#DCCEF2]" data-id="element-40" data-mp="36oxwmxa01aw9">Por la Dra. Karito</p>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-6 text-[#C8C1D2]" data-id="element-41" data-mp="3uf0obca04euc">
          El sistema de intervención clínica para terapeutas de habla hispana
          que quieren ejercer con autoridad y calma.
        </p>
        <p className="mt-8 border-t border-white/10 pt-5 text-[11px] text-[#AFA7B9]" data-id="element-42" data-mp="3leviv7odbqit">
          © 2026 El Oráculo del Terapeuta™ — Dra. Karito. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}